import type { UrlEntry, UrlRegion } from '@/types';

export const isIndexable = false;

export const urls: Record<'b2bApply', Partial<Record<UrlRegion, UrlEntry>>> = {
  b2bApply: {
    de: 'unternehmen/kontakt',
    'de-en': 'enterprise/contact',
    fr: 'entreprise/contact',
    'fr-en': 'enterprise/contact',
    gb: 'enterprise/contact',
    nl: 'bedrijven/contact',
    'nl-en': 'enterprise/contact',
    pt: 'empresa/contacto',
    'pt-en': 'enterprise/contact',
    us: 'enterprise/contact',
    ww: 'enterprise/contact',
  },
};
